import { Navigation } from '@angular/router';

export function isBackNavigation(navigation: Navigation | null) {
  return (
    navigation?.extras?.state?.['navigateBack'] === true ||
    navigation?.trigger === 'popstate'
  );
}
